import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ProvidersCard from "../../Components/ProvidersCard";
import WrapperSignupDetails from "../../Components/Wrappers/WrapperSignupDetails";
import useRegisterCompletedApi from "../../Global/Api/Signup/useRegisterCompletedApi";
import useGetProvidersApi from "../../Global/Api/Shared/useGetProvidersApi";

export default function SignupProviders() {
  const location = useLocation();
  const { data } = useGetProvidersApi();

  const { send } = useRegisterCompletedApi();

  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [pickedItem, setPickedItem] = useState(null);

  const handleButton = () => {
    send({ ...location?.state, provider_id: pickedItem });
  };

  useEffect(() => {
    if (pickedItem) {
      setButtonDisabled(false);
    }
  }, [pickedItem]);

  return (
      <WrapperSignupDetails
          isButtonDisabled={buttonDisabled}
          step="2"
          handleButton={handleButton}
      >
        <h1 className="register__subtitle">Which provider do you use?</h1>
        <div className="register__block">
          <div className="register__block__head">Techsbook Telematics</div>
          <div className="register__grid s4" style={{margin: '0'}}>
            {data?.filter((el) => !el.stripe_enabled)?.map((item) => (
                <ProvidersCard
                    key={item?.id}
                    title={item?.name}
                    id={item?.id}
                    name="provider"
                    image={item?.thumbnail}
                    setPickedItem={setPickedItem}
                    styles={{
                      border: "1.5px solid #eaeaea",
                      borderRadius: "8px",
                    }}
                />
            ))}
          </div>
        </div>
        <div className="register__block">
          <div className="register__block__head">Other providers</div>
          <div className="register__grid s4" style={{margin: '0'}}>
            {data?.filter((el) => el.stripe_enabled)?.map((item) => (
                <ProvidersCard
                    key={item?.id}
                    title={item?.name}
                    id={item?.id}
                    name="provider"
                    image={item?.thumbnail}
                    setPickedItem={setPickedItem}
                    styles={{
                      border: "1.5px solid #eaeaea",
                      borderRadius: "8px",
                    }}
                />
            ))}
          </div>
        </div>
      </WrapperSignupDetails>
  );
}
